import React from 'react';

const SlackIcon = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox='0 0 54 54' fill='currentColor'>
    <path d='M19.7 31.4c0 2.1-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8h3.8v3.8zm1.9 0c0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8v9.5c0 2.1-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8v-9.5zM25.4 19.7c-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8 3.8 1.7 3.8 3.8v3.8h-3.8zm0 1.9c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8h-9.5c-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8h9.5zM34.3 25.4c0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8-1.7 3.8-3.8 3.8h-3.8v-3.8zm-1.9 0c0 2.1-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8v-9.5c0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8v9.5zM28.6 34.3c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8-3.8-1.7-3.8-3.8v-3.8h3.8zm0-1.9c-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8h9.5c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8h-9.5z' />
  </svg>
);

export default SlackIcon;
